/**
 * Development environment configuration.
 * - Contains development-specific Firebase and API configurations.
 * - Used during development builds and during production builds.
 * - For Angular projects define your environment variables directly in environment.*.ts files.
 * - This file replaces `environment.ts` during production builds.
 * - Use .env files with dotenv only during the build process, not at runtime.
 */
import type { TEnvironment } from '@shared/models';

export const environment: TEnvironment = {
    production: false,
    googleMapsApiKey: 'AIzaSyAAuEBE-XgAos_OxYNMNDmJ27U9_-tciNg',
    recaptchaSiteKey: '6LeYY-MhAAAAACgciljA2EXNAnLYftQI4edEqIto',

    firebase: {
        projectId: 'shuttlenomix',
        appId: '1:728149494111:web:04bd7a164f31ad0e',
        databaseURL: 'https://shuttlenomix.firebaseio.com',
        storageBucket: 'shuttlenomix.appspot.com',
        locationId: 'us-central',
        apiKey: 'AIzaSyAAuEBE-XgAos_OxYNMNDmJ27U9_-tciNg',
        authDomain: 'shuttlenomix.firebaseapp.com',
        messagingSenderId: '728149494111',
        measurementId: 'G-8H9ESEZT3P'
    }
};

// import { config } from 'dotenv';
// config();
// export const environment: TEnvironment = {
//     production: false,
//     firebase: {
//         projectId: process.env['FIREBASE_PROJECT_ID'],
//         appId: process.env['FIREBASE_APP_ID'],
//         databaseURL: process.env['FIREBASE_DATABASE_URL'],
//         storageBucket: process.env['FIREBASE_STORAGE_BUCKET'],
//         locationId: process.env['FIREBASE_LOCATION_ID'],
//         apiKey: process.env['FIREBASE_API_KEY'],
//         authDomain: process.env['FIREBASE_AUTH_DOMAIN'],
//         messagingSenderId: process.env['FIREBASE_MESSAGING_SENDER_ID'],
//         measurementId: process.env['FIREBASE_MEASUREMENT_ID'],
//     },
//     googleMapsApiKey: process.env['GOOGLE_MAPS_API_KEY'],
//     recaptchaSiteKey: process.env['RECAPTCHA_SITE_KEY']
// };
